/**
 * Escapes G-code parameter patterns that look like HTML tags
 * Handles patterns like <0-7>, R<1-3>, A<slave device address base 10>, etc.
 */
export function escapeGcodeParameters(content: string): string {
  return (
    content
      // Basic parameter ranges
      .replace(/<(0-7)>/g, '&lt;$1&gt;')
      .replace(/<(1-3)>/g, '&lt;$1&gt;')
      .replace(/<(0-255)>/g, '&lt;$1&gt;')
      .replace(/<(0 or 1)>/g, '&lt;$1&gt;')

      // Parameters with letter prefixes (P<0-7>, R<1-3>, etc.)
      // Avoid matching closing tags like B</strong> by ensuring the bracketed content doesn't start with '/'
      .replace(/([PRBASM])<(?!\/)([^<>]+)>/g, '$1&lt;$2&gt;')

      // Complex parameter descriptions
      .replace(/<(slave device address base 10)>/g, '&lt;$1&gt;')
      .replace(/<(number of bytes)>/g, '&lt;$1&gt;')
      .replace(/<(style)>/g, '&lt;$1&gt;')
      .replace(/<(base 10)>/g, '&lt;$1&gt;')
  );
}
